export default "__VITE_ASSET__DNQfmC9___"